import React, { useEffect, useMemo, useState } from "react";
import { getUser } from "../../../services/utils";
import { WaitlistEntry } from "../Waitlist.types";
import { api } from "../../../services/api";
import { useAdminUsers } from "../../manageAdmin/context/AdminUsersContext";
import { AdminPermission } from "../../manageAdmin/AdminUserList.types";

export const WaitlistContext = React.createContext<{ waitlistEntries: Array<WaitlistEntry>; refreshEntries: () => {} }>({
  waitlistEntries: [],
  refreshEntries: () => ({}),
});

export function WaitlistProvider({ children }) {
  const { myPermissions } = useAdminUsers();
  const user = getUser();
  const [waitlistEntries, setWaitlistEntries] = useState<Array<WaitlistEntry>>([]);

  const fetch = useMemo(
    () => async () => {
      if (myPermissions?.includes(AdminPermission.READ_PAGE_MANAGE_WAITLIST)) {
        setWaitlistEntries(await api.getWaitlistEntries());
      }
    },
    [myPermissions]
  );

  useEffect(() => {
    if (user?.id) {
      fetch();
    }
  }, [user?.id, myPermissions]);

  const values = useMemo(
    () => ({
      waitlistEntries: waitlistEntries,
      refreshEntries: fetch,
    }),
    [waitlistEntries, fetch]
  );

  return <WaitlistContext.Provider value={values}>{children}</WaitlistContext.Provider>;
}

export function useWaitlist() {
  const context = React.useContext<{ waitlistEntries: Array<WaitlistEntry>; refreshEntries: () => {} }>(WaitlistContext);
  if (context === undefined) {
    throw new Error("useWaitlist must be used within a WaitlistProvider");
  }
  return context;
}
